<script lang="ts">
  interface Row {
    label: string;
    si: string;
    internal: string;
    corral: string;
  }

  interface Props {
    rows: Row[];
    variant?: 'dark' | 'light';
  }

  let { rows, variant = 'dark' }: Props = $props();

  const isDark = $derived(variant === 'dark');
</script>

<!-- Desktop table -->
<div class="hidden lg:block overflow-x-auto">
  <table class="w-full border-collapse">
    <thead>
      <tr>
        <th class="text-left py-4 px-4 font-mono text-[12px] uppercase tracking-wider {isDark ? 'text-[#878787] border-b border-[#333335]' : 'text-[#5C5855] border-b border-[#D3D3D3]'}"></th>
        <th class="text-left py-4 px-4 font-mono text-[12px] uppercase tracking-wider {isDark ? 'text-[#878787] border-b border-[#333335]' : 'text-[#5C5855] border-b border-[#D3D3D3]'}">SI Engagement</th>
        <th class="text-left py-4 px-4 font-mono text-[12px] uppercase tracking-wider {isDark ? 'text-[#878787] border-b border-[#333335]' : 'text-[#5C5855] border-b border-[#D3D3D3]'}">Internal Build</th>
        <th class="text-left py-4 px-4 font-mono text-[12px] uppercase tracking-wider {isDark ? 'text-[#ee6018] border-b border-[#333335]' : 'text-[#ee6018] border-b border-[#D3D3D3]'}">Corral</th>
      </tr>
    </thead>
    <tbody>
      {#each rows as row}
        <tr>
          <td class="py-4 px-4 font-sans font-medium text-[15px] {isDark ? 'text-white border-b border-[#333335]/50' : 'text-[#020202] border-b border-[#D3D3D3]/50'}">{row.label}</td>
          <td class="py-4 px-4 font-mono font-light text-[14px] {isDark ? 'text-[#878787] border-b border-[#333335]/50' : 'text-[#5C5855] border-b border-[#D3D3D3]/50'}">{row.si}</td>
          <td class="py-4 px-4 font-mono font-light text-[14px] {isDark ? 'text-[#878787] border-b border-[#333335]/50' : 'text-[#5C5855] border-b border-[#D3D3D3]/50'}">{row.internal}</td>
          <td class="py-4 px-4 font-mono font-light text-[14px] {isDark ? 'text-white border-b border-[#333335]/50' : 'text-[#020202] border-b border-[#D3D3D3]/50'}">{row.corral}</td>
        </tr>
      {/each}
    </tbody>
  </table>
</div>

<!-- Mobile: stacked cards -->
<div class="lg:hidden flex flex-col gap-6">
  {#each rows as row}
    <div class="{isDark ? 'bg-[#171719] border-[#333335]' : 'bg-white border-[#D3D3D3]'} border p-4">
      <h4 class="font-sans font-medium text-[15px] {isDark ? 'text-white' : 'text-[#020202]'} mb-3">{row.label}</h4>
      <div class="flex flex-col gap-2">
        <div>
          <span class="font-mono text-[11px] uppercase tracking-wider {isDark ? 'text-[#878787]' : 'text-[#5C5855]'}">SI Engagement</span>
          <p class="font-mono font-light text-[14px] {isDark ? 'text-[#878787]' : 'text-[#5C5855]'}">{row.si}</p>
        </div>
        <div>
          <span class="font-mono text-[11px] uppercase tracking-wider {isDark ? 'text-[#878787]' : 'text-[#5C5855]'}">Internal Build</span>
          <p class="font-mono font-light text-[14px] {isDark ? 'text-[#878787]' : 'text-[#5C5855]'}">{row.internal}</p>
        </div>
        <div>
          <span class="font-mono text-[11px] uppercase tracking-wider text-[#ee6018]">Corral</span>
          <p class="font-mono font-light text-[14px] {isDark ? 'text-white' : 'text-[#020202]'}">{row.corral}</p>
        </div>
      </div>
    </div>
  {/each}
</div>
